module.exports = __webpack_public_path__ + "img/@yellow_arrow.1d90c126.jpg";